module.exports = __webpack_public_path__ + "static/media/feature5.38cddc9a.png";